import _ from '@/utils/lodash-optimized'
import { Component } from 'react'

import { USStateCodes } from '../../../lib/Codes'
import { capitalizeSentence } from '../../../lib/Form'
import http, { isAbortErr } from '../../../lib/http'
import { AutoComplete, Select } from '../NarusMaterial'

import { makeAutobindedInput } from './FormBuilder'
import { humanName } from './UtilityFunctions'

const mapCodes = options =>
  options.map(o => ({
    label: o.display || o.label,
    value: o.code || o.value
  }))

const textFunc = obj => {
    const name = humanName(obj?.resource?.name)
  return `${capitalizeSentence(name)}`
}

const displayFunc = obj => {
    const name = humanName(obj?.resource?.name)
  const prefix = _.join(_.compact(obj?.resource?.name?.[0]?.prefix ?? []), ' ')
  return `${prefix} ${capitalizeSentence(name)}`
}

// const valueFunc = (v) => (v ? { resource: v } : null);

class _NPIPractitionerAutoCompleteSelect extends Component {
  constructor (props) {
    super(props)
    this.state = {
      state: 'TN'
    }
    this.dataFunc = this.dataFunc.bind(this)
    this.handle = this.handle.bind(this)
    this.handleState = this.handleState.bind(this)
    this.searchErrors = this.searchErrors.bind(this)

    this.abortController = new AbortController()
  }

  handleState (e) {
    this.setState({
      state: e.target.value
    })
  }

  dataFunc (text) {
    const { state } = this.state
    if (state === 'null') {
      return Promise.resolve(undefined)
    }

    if (text && text.length > 0) {
      this.abortController.abort()
      this.abortController = new AbortController()

      return new Promise(resolve => {
        const search = {
          q: text,
          attrs: 'name',
          state
        }
        http
          .getRequest(
            encodeURI('/terminology/npi/practitioners/lookup'),
            search,
            {
              signal: this.abortController.signal
            }
          )
          .then(data => {
            if (!data.entry) {
              resolve(
                'Sorry, could not perform a search. Please use more specific term.'
              )
            } else if (data.entry.length === 0) {
              resolve('Sorry, no results found.')
            } else {
              resolve(data.entry)
            }
          })
          .catch(err => {
            if (isAbortErr(err)) {
              return
            }

            resolve('Sorry, could not make a search. Error occurred.')
          })
      })
    }
    return Promise.resolve(
      'Please enter search criteria for NPI Practitioners'
    )
  }

  handle (v) {
    const { onChange } = this.props
    const errors = this.searchErrors()
    if (errors && errors.length > 0) {
      return false
    }
    if (onChange && v) {
      onChange(v.resource)
    }
    return null
  }

  searchErrors () {
    const { state } = this.state
    if (!state || state === 'null') {
      return [ 'Please select a state' ]
    }
    return null
  }

  render () {
    const { label, value } = this.props
    const { state } = this.state
    const val = value ? { resource: value } : ''
    return (
      <div className='row'>
        <div className='col-xs-12 col-sm-8'>
          <AutoComplete
            label={label}
            dataFunc={this.dataFunc}
            textFunc={textFunc}
            displayFunc={displayFunc}
            value={val}
            onChange={this.handle}
          />
        </div>
        <div className='col-xs-12 col-sm-4'>
          <Select
            label='Select State'
            data={mapCodes(USStateCodes)}
            onChange={this.handleState}
            value={state}
            errors={this.searchErrors()}
          />
        </div>
      </div>
    )
  }
}

export const NPIPractitionerAutoCompleteSelect = makeAutobindedInput(
  _NPIPractitionerAutoCompleteSelect
)
